import { literal, struct, union } from 'io-ts/Decoder';

/**
 * The only changes the public unsubscribe page can make: turn the link's topic off or back on
 * for the link's organisation, or turn every email off everywhere.
 */
export const Request = struct({
	action: union(literal('unsubscribe'), literal('resubscribe'), literal('unsubscribe-all')),
});
